export default __webpack_public_path__ + "static/media/success-icon.4260fd9e.svg";